// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"88fda1de","268":"3e693485","358":"57ec05b5","457":"8880049a","551":"f9c27859"}[chunkId] + ".chunk.js";
};